// extracted by mini-css-extract-plugin
export default {"whatsapp":"ButtonWhatsapp_whatsapp__Y3ygL","icon_whatsapp":"ButtonWhatsapp_icon_whatsapp__LEw7K"};